import React from "react";
import _ from "lodash";
import { inject, observer } from "mobx-react";
import LazyLoad from "react-lazyload";
import PlaceHolder from "pages/viewer-dashboard/section/gridViewportSection/placeholder";
import Viewport from "component/molecules/viewport";
import Config from "config"; // 프로그램 환경설정 모듈
import Helper from "helper";

@inject("toolbarStore")
@inject("gridLayoutStore")
@inject("metadataStore")
@observer
class DCMViewContainer extends React.Component {
  calculateFrameRange = (
    number,
    orientationName,
    isBatchMode,
    defaultFrameIdx,
    numOfFrames
  ) => {
    const { gridLayoutStore } = this.props;

    const layoutRows = gridLayoutStore.getLayoutRows();
    const layoutColumns = gridLayoutStore.getLayoutColumns();
    const totalPages = Math.max(gridLayoutStore.getLayoutTotalPages(), 1);
    const numOfDCMView = layoutRows * layoutColumns * totalPages;
    let frameRange = { min: -1, max: -1 };
    if (orientationName === "axial") {
      if (isBatchMode === true) {
        if (number === numOfDCMView - 1) {
          // 마지막 DCMView 인 경우, 남은 영상 Frame을 모두 제어해서 볼수 있도록 한다.
          frameRange["min"] = defaultFrameIdx;
          frameRange["max"] = numOfFrames - 1;
        } else {
          // 마지막 DCMView 가 아닌 경우, 한개 Frame 만 출력
          frameRange["min"] = defaultFrameIdx;
          frameRange["max"] = defaultFrameIdx;
        }
      } else {
        frameRange["min"] = defaultFrameIdx;
        frameRange["max"] = numOfFrames - 1;
      }
    } else if (orientationName === "coronal") {
      frameRange["min"] = 0;
      frameRange["max"] = 512 - 1; // 임시
    } else if (orientationName === "sagittal") {
      frameRange["min"] = defaultFrameIdx;
      frameRange["max"] = 512 - 1; // 임시
    }

    return frameRange;
  };

  isFocus = (number) => {
    const { gridLayoutStore } = this.props;
    const focusDCMViewIdx = gridLayoutStore.getFocusOneDCMViewIdx();
    let focus = false;
    if (focusDCMViewIdx === number) {
      focus = true;
    }
    return focus;
  };

  render() {
    const { gridLayoutStore, metadataStore, number, width, height } =
      this.props;
    // console.log("Viewing");
    let data = gridLayoutStore.getMetadataIDOnDCMView(number);
    let orientationName = gridLayoutStore.getMPROptionName(number);
    let imageOrientation = [1, 0, 0, 0, 1, 0];
    if (orientationName === "coronal") {
      imageOrientation = [1, 0, 0, 0, 0, -1];
    } else if (orientationName === "sagittal") {
      imageOrientation = [0, 1, 0, 0, 0, -1];
    }

    let defaultFrameIdx = gridLayoutStore.getDefaultFrameIdx(number);
    if (defaultFrameIdx === undefined || defaultFrameIdx === null) {
      defaultFrameIdx = 0;
    }

    const isActive = gridLayoutStore.isActiveDCMView(number);
    const numOfFrames = metadataStore.getNumberOfFrames(data);
    const isBatchMode = gridLayoutStore.getIsBatchMode(number);
    const isMPR = gridLayoutStore.getIsMPR(number);
    const colorBox = gridLayoutStore.getColorBox(number);
    const onInitCallback = gridLayoutStore.getOnInitCallback(number);
    const layoutRows = gridLayoutStore.getLayoutRows();
    const layoutColumns = gridLayoutStore.getLayoutColumns();
    const layoutString = layoutRows + "x" + layoutColumns;
    const showTagOverlay = gridLayoutStore.isShowTagOverlayOnDCMView(number);
    const frameRange = this.calculateFrameRange(
      number,
      orientationName,
      isBatchMode,
      defaultFrameIdx,
      numOfFrames
    );
    const focus = this.isFocus(number);

    return (
      <Viewport
        data={data} // @FIXME : 변수이름 변경
        defaultFrameIdx={defaultFrameIdx}
        frames={numOfFrames}
        displayRange={frameRange} // @FIXME : 이름을 clip으로 변경할것
        imageOrientation={imageOrientation}
        showTagOverlay={!!showTagOverlay}
        isMPR={isMPR}
        colorBox={colorBox}
        scrollLoop={Config.control.dcmViewScrollLoop}
        id={"viewport-" + number} // 없앨것
        identifier={number} //
        layoutString={layoutString}
        width={width}
        height={height}
        focus={focus}
        isActive={isActive}
        onInitCallback={onInitCallback}
      />
    );
  }
}

export default DCMViewContainer;
